import { useLanguage } from "../context/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-ink/10 bg-travertine py-6 select-none">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-2xl sm:text-3xl text-ink/70 px-8">{item}</span>
                <span className="text-gold text-xs">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
